var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoRoomWithAView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-city-1893026",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.002,
    height: 24.002,
    viewBox: "0 0 24.002 24.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12226",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12226",
    d: "M457.031,407.81a.511.511,0,0,0-.5.5v2.16h-2.777v2.661h6.6v-2.661H457.57v-2.16a.576.576,0,0,0-.54-.5Z",
    transform: "translate(-447.594 -403.619)",
    fill: "#1d1d1f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12227",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12227",
    d: "M335.627,551.2a2.964,2.964,0,0,0-.479,5.863c0,.039-.037.077-.037.116v3.587h-5.937V547.5h-9.366v13.307h-3.392a.5.5,0,0,0,0,1h21.276a.5.5,0,0,0,0-1h-1.549v-3.587a.146.146,0,0,0-.037-.116,2.986,2.986,0,0,0-.479-5.9Zm-12.8-1h3.282a.386.386,0,0,1,0,.771h-3.282a.378.378,0,0,1-.369-.386A.406.406,0,0,1,322.832,550.2Zm0,3.009h3.282a.378.378,0,0,1,.369.386.357.357,0,0,1-.369.386h-3.282a.386.386,0,0,1,0-.771Zm0,4.011h3.282v3.587h-3.282Z",
    transform: "translate(-315.082 -537.809)",
    fill: "#1d1d1f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12228",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12228",
    d: "M768.817,306.263v-1.08a.5.5,0,0,0-1,0v1.08a.5.5,0,0,0,1,0Z",
    transform: "translate(-749.207 -304.663)",
    fill: "#1d1d1f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12229",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12229",
    d: "M701.388,328.509a.491.491,0,1,0-.694.694l.771.771a.471.471,0,0,0,.347.154.419.419,0,0,0,.347-.154.489.489,0,0,0,0-.694Z",
    transform: "translate(-684.614 -327.371)",
    fill: "#1d1d1f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12230",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12230",
    d: "M817.71,328.509l-.771.771a.489.489,0,0,0,0,.694.471.471,0,0,0,.347.154.419.419,0,0,0,.347-.154l.771-.771a.491.491,0,1,0-.694-.694Z",
    transform: "translate(-796.37 -327.371)",
    fill: "#1d1d1f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12231",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12231",
    d: "M853.587,383.532a.54.54,0,0,0,.463.347.232.232,0,0,0,.154-.039l1.08-.347a.512.512,0,1,0-.347-.964l-1.08.347a.6.6,0,0,0-.27.656Z",
    transform: "translate(-831.629 -379.27)",
    fill: "#1d1d1f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12232",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12232",
    d: "M658.231,382.893a.512.512,0,1,0-.347.964l1,.347a.232.232,0,0,0,.154.039.485.485,0,0,0,.463-.347.532.532,0,0,0-.309-.656Z",
    transform: "translate(-643.313 -379.634)",
    fill: "#1d1d1f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12233",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12233",
    d: "M666.239,423.16a13.316,13.316,0,0,1-3.279,0c-.463-.077-.849-.154-1.2-.231a6.939,6.939,0,0,0-1.7-.231,7.969,7.969,0,0,0-3.124.54.512.512,0,1,0,.347.964,7.78,7.78,0,0,1,2.738-.5,5.829,5.829,0,0,1,1.466.231c.347.077.733.154,1.273.231a13.858,13.858,0,0,0,1.813.116,13.12,13.12,0,0,0,1.736-.116.5.5,0,0,0,.424-.579c.039-.231-.193-.424-.5-.424Z",
    transform: "translate(-642.778 -417.886)",
    fill: "#1d1d1f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12234",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12234",
    d: "M296.406,500.791l.733-.116a1.219,1.219,0,0,1,.193-.733.9.9,0,0,1,.27-.27.386.386,0,1,0-.463-.617,2.21,2.21,0,0,0-.424.424,1.154,1.154,0,0,0-.154.309c-.039,0-.039-.039-.077-.039a1.908,1.908,0,0,0-1-.193.371.371,0,1,0,.116.733.9.9,0,0,1,.5.077.715.715,0,0,1,.309.424Z",
    transform: "translate(-295.165 -491.087)",
    fill: "#1d1d1f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12235",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12235",
    d: "M426.516,304.312a2.212,2.212,0,0,0-.424.424.775.775,0,0,0-.154.309c-.039,0-.039-.039-.077-.039a1.907,1.907,0,0,0-1-.193.371.371,0,1,0,.116.733.9.9,0,0,1,.5.077.584.584,0,0,1,.309.386l.733-.116a1.219,1.219,0,0,1,.193-.733.9.9,0,0,1,.27-.27.408.408,0,0,0,.077-.54A.373.373,0,0,0,426.516,304.312Z",
    transform: "translate(-419.466 -304.216)",
    fill: "#1d1d1f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12236",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12236",
    d: "M713.44,364.483c.424-.039.81-.077,1.234-.077a7.562,7.562,0,0,1,1.736.231c.347.077.694.154,1.157.231a10.516,10.516,0,0,0,1.581.116,3.012,3.012,0,0,0-2.43-2.854,2.853,2.853,0,0,0-2.2.617,3.182,3.182,0,0,0-1.08,1.736Z",
    transform: "translate(-697.268 -359.719)",
    fill: "#1d1d1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRoomWithAView);
export default __webpack_public_path__ + "static/media/icoRoomWithAView.81f1b5b8fd4c529b1f9f59bfc99dd3b8.svg";
export { ForwardRef as ReactComponent };